import React, {useContext, useEffect, useState} from 'react';
// import { Link, Redirect } from 'react-router-dom';
// import { connect } from 'react-redux';
import UserContext from '../../context/context'
import styled from 'styled-components';
// from {Redirect} import 'react-router-dom'
import { tagOptions } from '../SignIn/data';



let user = localStorage.getItem('user')


function Modal({ isShowing, hide, init}){
  

  const [state, actions] = useContext(UserContext);

  const [disabled, setDisabled] = useState(false)

  useEffect(()=>{

    // if(state.tags.length > 3){
    //   setDisabled(true)
    // }
    
  }, [])
  
  function handleTags(item){

    if(state.tags.includes(item.value)){
      actions.setTags(state.tags.filter((e)=>e !== item.value))
    }
    else
      actions.setTags(oldArray => [...oldArray, item.value])

  }
  
  console.log(state.tags)
  console.log("MODAL")
  return(
    <>
      <Overlay className="modal-overlay" onClick={hide}/>
      {console.log("modal")}
      <SelectDiv>
        {/* <div>
          3개만 선택 가능
        </div> */}
        <div className={"tag-title"}>
          태그 선택
        </div>
        <div className={"tag"}>
          {tagOptions.map((item, index) =>{
            return(
            <>
              {state.tags.includes(item.value)?
                <input checked type="checkbox" name="checkbox" id={item.value} value={item.value} 
                onChange={()=>handleTags(item)}
                />
                :
                state.tags.length > 2?
                <input type="checkbox" name="checkbox" id={item.value} value={item.value} 
                onChange={()=>handleTags(item)}
                disabled={true} />
                :
                <input type="checkbox" name="checkbox" id={item.value} value={item.value} 
                onChange={()=>handleTags(item)}
                disabled={false} />
              }

              <label for={item.value}>{item.value}</label>  
            </>
            )
          })}
        </div>

        <div className={"warning"}>
          최대 3개만 선택 가능
        </div>
        <button onClick={init} >
          확인
        </button>
        
      </SelectDiv>
    </>
  )
}
// const Modal = ({ isShowing, hide, logout }) => user ? null : isShowing ? ReactDOM.createPortal(
    
//     <React.Fragment>
//         <Overlay className="modal-overlay" onClick={hide}/>
//         {console.log("modal")}
//         <SelectDiv>

//         </SelectDiv>
//     </React.Fragment>, document.body
//   ) : null;

// export { connectedLoginPage as LoginPage };


const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  opacity: .5;
  
`
const SelectDiv = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: calc(50% - 300px);
  left: calc(50% - 200px);
  width: 400px;
  height: 600px;
  background-color: white;
  z-index: 20000;

  .tag-title{
    position: absolute;
    top: 15px;
    font-size: 1.2rem;
    color: rgba(253,134,18, 1);
    font-weight: bold;
  }

  .tag{
    display: flex;
    height: auto;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    >label{
      
      border-radius: 20px;
      color: rgba(0, 0, 0, .6);
      background-color: rgba(253,134,18, 0.2);
      cursor: pointer;
      padding: 10px;
      margin: 5px;
      min-width: 50px;
      transition: .1s;
      
    }
    >input[type="checkbox"]{
      position: absolute;
      top: 0;
      opacity: 0;
      :checked + label{
        border-radius: 20px;
        background-color: rgba(253,134,18, 0.6);
        padding: 10px;
        margin: 5px;
        cursor: pointer;
        color: white;
        transition: .1s;
        min-width: 50px;
      }
    }
    
  }

  .warning{
    
    position: absolute;
    bottom: 75px;
    font-size: 0.8rem;
    color: grey;
  }
  

  >button{
    background-color: rgba(253,134,18);
    position: absolute;
    bottom: 15px;
    width: 80%;
    height: 50px;
    border: none;
    color: white;
    border-radius: 10px;

    font-size: 1.2rem;
    text-align: center;
    /* letter-spacing: 6px; */
    font-weight: bold;
  }
`

export default Modal;